import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import moment from 'moment'

import { Button } from 'controls'

import styles from './styles'

class ShiftOptions extends PureComponent {
  static propTypes = {}

  static defaultProps = {
    shifts: []
  }

  onShiftSelected = (shift, available) => () => {
    if (!available) {
      return
    }

    this.props.onShiftSelected(shift)
  }

  render() {
    return (
      <div className="shifts">
        <div className="shifts-container">
          {this.props.shifts.map((shift, index) => {
            const now = new Date().valueOf()
            const available = shift.available && shift.start > now
            const selected =
              this.props.selectedShift &&
              shift.start === this.props.selectedShift.start
            return (
              <div
                key={index}
                onClick={this.onShiftSelected(shift, available)}
                className={classnames('shift-option', {
                  available,
                  selected
                })}
              >
                {moment(shift.start).format('HH:mm')}
              </div>
            )
          })}
        </div>
        <div className="reference-container">
          <div className="reference">
            <div className="reference-dot" />
            <span className="reference-text">No disponible</span>
          </div>
          <div className="reference">
            <div className="reference-dot enabled" />
            <span className="reference-text">Disponible</span>
          </div>
          <div className="reference">
            <div className="reference-dot selected" />
            <span className="reference-text">Seleccionado</span>
          </div>
        </div>
        <style jsx>{styles}</style>
      </div>
    )
  }
}

export default ShiftOptions
